import React from "react";
import { Link } from "react-router-dom";
import "./styles/AdList.css";
import MiniLoader from "../components/MiniLoader";
import { connect } from "react-redux";
import * as actions from "../redux/actions/adActions";
import * as actions_store_ad from "../redux/actions/marketstoreAdListActions";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import ProductCard, { getKindCommerceLabel } from "./ProductCard";

class StoreAdList extends React.Component {

  onClick = (item) => {
    this.props.SetAd(item);
  };

  async componentDidMount() {
    if (this.props.marketstore?.Id) {
      this.fetchLoadAdList(this.props.marketstore.Id);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.marketstore?.Id !== this.props.marketstore?.Id &&
      this.props.marketstore?.Id
    ) {
      this.fetchLoadAdList(this.props.marketstore.Id);
    }

    if (prevProps.loading && !this.props.loading && this.props.error) {
      alertify.warning(I18n.t(this.props.error));
    }
  }

  fetchLoadAdList = async (marketstoreId) => {
    if (!marketstoreId) return;

    try {
      await this.props.LoadAdStore(
        marketstoreId,
        this.props.user_id,
        this.props.token
      );
    } catch (error) {
      console.log(error);
    }
  };

  componentWillUnmount() {
    this.props.ClearAdStore();
  }

  onClickLoadMore = async () => {
    if (!this.props.marketstore?.Id) return;

    try {
      await this.props
        .LoadAdStoreMore(
          this.props.pageCount,
          this.props.marketstore.Id,
          this.props.user_id,
          this.props.token
        )
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    if (!this.props.loading && this.props.pageCount === 0)
      return (
        <h3>
          <Translate value="ad_not_list" />
        </h3>
      );

    if (this.props.loading) return <MiniLoader />;

    return (
      <React.Fragment>
        <div className="product-card-list">
          {this.props.storeAdList.map((item) => (
            <ProductCard
              key={item.Id}
              item={item}
              kindCommerce={getKindCommerceLabel(item.KindCommerceId)}
              columnClass="product-card-list__item"
              onClick={() => this.onClick(item)}
            />
          ))}
        </div>
        {this.props.pageSize >= 6 &&
          (this.props.loadingMore ? (
            <div className="text-center">
              <MiniLoader />
            </div>
          ) : (
            <div className="product-card-load-more">
              <button
                type="button"
                className="product-card-load-more-btn"
                onClick={this.onClickLoadMore}
              >
                <Translate value="load_more" />
              </button>
            </div>
          ))}
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,

    marketstore: reducer.marketstore.item,
    marketstore_loading: reducer.marketstore.loading,

    storeAdList: reducer.marketstoreAdList.list,
    loading: reducer.marketstoreAdList.loading,
    error: reducer.marketstoreAdList.error,

    pageSize: reducer.marketstoreAdList.page_size,
    pageCount: reducer.marketstoreAdList.page_count,
    loadingMore: reducer.marketstoreAdList.loadingMore,
  };
}
const mapDispatchToProps = (dispatch) => ({
  SetAd: (item) => dispatch(actions.setAd({ item })),
  LoadAdStore: (id, user_id, token) =>
    dispatch(actions_store_ad.loadList({ id, user_id, token })),
  LoadAdStoreMore: (page_count, id, user_id, token) =>
    dispatch(actions_store_ad.loadListScroll({ page_count, id, user_id, token })),
  ClearAdStore: () => dispatch(actions_store_ad.clearAdStore({})),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoreAdList);
